export default __webpack_public_path__ + "static/media/pin-question.f4bf1fb6.svg";